
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trademark-objections-landing-page",
      function () {
        return require("private-next-pages/trademark-objections-landing-page/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trademark-objections-landing-page"])
      });
    }
  